/**
 * Templates saved before TPL-2470 carry the Loop Block text `font-size` as a
 * bare number (copied from a former global mj-text default). A bare number is
 * invalid CSS, so the editor normalizes it when loading a template and
 * unified-be when emitting MJML. Shared so both sides agree on what counts as
 * a unitless value: a number, or a string holding only a number.
 */
export function withPxUnit<T>(value: T): T | string {
  if (typeof value === "number") return `${value}px`;
  if (typeof value === "string" && /^\s*\d+(\.\d+)?\s*$/.test(value)) {
    return `${value.trim()}px`;
  }
  return value;
}
